module.exports = __webpack_public_path__ + "img/test2.bc03d2f0.gif";